
<template>
  <div>
	<CRow>
		<CCol sm="12">
			<CCard class='tablewrapper'>
				<CCardHeader>
					<CIcon name="cil-grid"/> ログインアカウント管理
				</CCardHeader>
				<CCardBody>
				<CRow class="my-2">
          <CCol sm="6" class="form-inline">
          </CCol>
					<CCol sm="6" class="text-right">
						<CButton color="info" @click='showRecordModal()'>新規作成</CButton>
					</CCol>
				</CRow>
				<CDataTable
					:hover="true"
					:striped="true"
					:items="users"
					:loading="isLoading"
					:fields="fields"
					:itemsPerPage="20"
					class='table-scroll'
				>
					<template #created_at="{item}">
						<td class="py-2">
							{{ formatDate(item.created_at)}}
						</td>
					</template>
					<template #show_details="{item}">
						<td class="py-2">
							<CButton class="mr-2" color="danger" variant="outline" square size="sm" @click="showDeleteModal(item)">削除</CButton>
							<CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item)">編集</CButton>
						</td>
					</template>
          <template #role="{item}">
						<td class="py-2">
              {{ item.role == "super_admin" ? "システム管理者" : item.role == "admin" ? "管理者" : "メンバー" }}
						</td>
					</template>
				</CDataTable>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
	<CModal
		:title="isCreate ? 'ログインアカウント追加' : '更新'"
		color="dark"
		:show.sync="recordModal"
	>
		<CRow class="form-box">
			<CCol sm="12">
				<label class="record-label pt-3">氏名</label>
				<CInput placeholder="先生名" v-model="record.name" :class="{ 'hasError': $v.record.name.$error }"/>

				<small v-if="$v.record.name.$error" class="errorLabel">氏名が不正です</small>
			</CCol>
			<CCol sm="12">
				<label class="record-label pt-3">メールアドレス</label>
				<CInput placeholder="Email" v-model="record.email" :class="{ 'hasError': $v.record.email.$error }" />
				<small v-if="$v.record.email.$error" class="errorLabel">メールアドレスが不正です</small>
			</CCol>
			<CCol sm="12">
				<label class="record-label pt-3">パスワード</label>
				<CInput placeholder="パスワード" v-model="record.password" :class="{ 'hasError': $v.record.password.$error }"/>
				<small v-if="$v.record.password.$error" class="errorLabel">パスワードが不正です</small>
			</CCol>
			<CCol sm="12">
				<label class="record-label pt-3">権限</label>
				<CSelect
          placeholder="権限を選択"
					:class="{ 'hasError': $v.record.role.$error }"
					:options="roleType"
					:value.sync="record.role"
				/>
				<small v-if="$v.record.role.$error" class="errorLabel">権限が不正です</small>
			</CCol>
		</CRow>

		<template #footer>
			<CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
			<CButton size="sm" color="info" @click="createUser()">{{ isCreate ? '登録' : '更新' }}</CButton>
		</template>
	</CModal>

	<CModal
		title="削除しますか？"
		color="danger"
		:show.sync="deleteModal"
	>
		<div class="text-center">
			<p>この先生アカウントを削除しますか？？</p>
			<p>削除してしまうと復元することはできません</p>
		</div>
		<template #footer>
			<CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
			<CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
		</template>
	</CModal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { required, requiredIf, email } from "vuelidate/lib/validators";

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      isLoading: false,
      recordModal: false,
      deleteModal: false,
      record: {
        name: '',
        email: '',
        password: '',
        role: 0,
      },
      users: [],
      roleType:[
        {'value': 'super_admin', 'label': 'システム管理者'},
        {'value': 'admin', 'label': '管理者'},
        {'value': 'member', 'label': 'メンバー'},
      ],
      fields: [
        { key: 'id', label: "ID"},
        { key: 'created_at', label: "作成日"},
        { key: 'name', label: "氏名"},
        { key: 'email', label: "メールアドレス"},
        { key: 'role', label: "権限"},
        { key: 'show_details', label: '',  _style: 'width:15%', sorter: false, filter: false},
      ],
      isCreate: false
    }
  },
	validations: {
		record: {
			name: {required},
			email: {required, email},
			password: {
        required: requiredIf(function () {
          return this.isCreate
        })
      },
			role: {required},
		}
	},
  methods: {
    showRecordModal: function(item, index) {
      this.$v.record.$reset();
      this.recordModal = true
      this.index = index
      if(item) {
        this.isCreate = false
        this.record = {}
        this.record = JSON.parse(JSON.stringify(item))
      } else {
        this.isCreate = true
        this.record = {}
      }
    },
    hideRecordModal: function() {
        this.recordModal = false
    },
    createUser: function() {
      this.$v.record.$touch();
      if(this.$v.record.$error) return
      this.record.role = this.record.role === 'super_admin' ? 0 : this.record.role === 'admin' ? 1 : 2
      if(this.isCreate) {
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/api/mng/users", {"user": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.notifyVue("Success")
            this.hideRecordModal()
            this.fetchUser()
          }).catch(error => {
            this.notifyVue(error.response.data.errors[0], 'error')
            this.hideRecordModal()
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/api/mng/users/" + this.record.id, {"user": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.notifyVue("Success")
            this.hideRecordModal()
            this.fetchUser()
          }).catch(error => {
            this.notifyVue(error.response.data.errors[0], 'error')
            this.hideRecordModal()
          })
      }

    },
    formatOmit(data){
      if(data != undefined || data != null){
        return data.length > 10 ? (data).slice(0,10)+"…" : data;
      }
      else{
        return ''
      }
    },
    formatDate(date){
        return moment(date).format("YYYY,MM,DD  HH:mm")
    },
    showDeleteModal(data) {
        this.record = data
        this.deleteModal = true
    },
    hideDeleteModal() {
      this.deleteModal = false
    },
    fetchUser: function() {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/users", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.users = response.data
        }).catch(error => {
          this.notifyVue(error.response.data.errors[0], 'error')
        })
    },
    deleteItem() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/api/mng/users/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.fetchUser()
        }).catch(error => {
          this.notifyVue(error.response.data.errors[0], 'error')
        })
    }
  },
  mounted() {
		this.fetchUser()
  },
	computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
<style scoped>
.tablewrapper{
  overflow-x: scroll;
}
.table-scroll{
  border-collapse: collapse;
  white-space: nowrap;
}
.red{
  color: red
}
</style>
